import { useEffect } from 'react';
import styled from 'styled-components';
import { AdType } from '../../constants/ads';
import AdUnit from './AdUnit';

const MIN_HEIGHT_ATTR = 'data-skyboxminheight';

const StyledSkyboxContainer = styled.div`
  text-align: center;

  body:not(.skybox-loaded) & .ad {
    position: fixed;
    z-index: 101;
    bottom: 0;
    margin: 0 auto;

    width: 100%;
  }
`;

interface ISkyboxAdUnitProps {
  preferDesktop: boolean;
  setHeight: (height: number) => void;
}

const SkyboxAdUnit: React.FC<ISkyboxAdUnitProps> = ({
  preferDesktop,
  setHeight
}) => {
  const adCode = preferDesktop ? AdType.DesktopSkybox : AdType.MobileSkybox;

  useEffect(() => {
    const element = document.getElementById(adCode);

    const observer = new MutationObserver(mutations => {
      if (!setHeight) return;

      mutations.forEach(mutationRecord => {
        const { target, type, attributeName } = mutationRecord;

        const isBlank = (target as any)?.style?.display === 'none';
        // Blank
        if (isBlank) {
          return;
          // console.log('SKYBOX_DEBUG - blank (BB)');
        }

        let newTopMargin = 0;
        const isSkybox = document.body.classList.contains('skybox-loaded');

        if (
          type === 'attributes' &&
          attributeName === MIN_HEIGHT_ATTR &&
          isSkybox
        ) {
          // console.log('SKYBOX_DEBUG - True Skybox');
          newTopMargin =
            parseInt(
              (mutationRecord.target as any).getAttribute(MIN_HEIGHT_ATTR)
            ) || 0;
        }
        // Regular ad
        // else if (type === 'childList' && !isSkybox) {
        //   // console.log('SKYBOX_DEBUG - Regular Ad');
        // } else {
        //   // console.log('SKYBOX_DEBUG - Other');
        // }

        // eslint-disable-next-line no-unused-expressions
        setHeight(newTopMargin);

        // console.log('SKYBOX_DEBUG - New Top Margin', newTopMargin);
      });
    });

    // console.log('MPAd', 'Skybox observer.observe()');

    if (element) {
      observer.observe(element, {
        attributes: true,
        childList: true,
        attributeFilter: [MIN_HEIGHT_ATTR, 'style']
      });
    }

    return () => {
      // console.log('MPAd', 'Skybox observer.disconnect()');
      observer.disconnect();
    };
  }, [adCode, setHeight]);

  return (
    <StyledSkyboxContainer>
      <AdUnit code={adCode} />
    </StyledSkyboxContainer>
  );
};

export default SkyboxAdUnit;
